import { BaseAssessment } from './draftassessment';

export interface InReviewAssessmentDTO extends BaseAssessment {}

export class InReviewAssessment implements InReviewAssessmentDTO {
  id: number = 0;
  created: string = '';
  lastModified: string = '';
  startedByFullName: string = '';
  ownerFullName: string = '';

  constructor(dto: InReviewAssessmentDTO) {
    this.update(dto);
  }

  get asJson(): InReviewAssessmentDTO {
    return {
      id: this.id,
      created: this.created,
      lastModified: this.lastModified,
      ownerFullName: this.ownerFullName,
    };
  }

  update(newData: Partial<InReviewAssessmentDTO>): InReviewAssessmentDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}
